import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_WORKLOAD_CONFIGURATIONS,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_EDGE_WORKLOAD_CONFIGURATIONS,
} from '../constants';

const api = (solutionId) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_WORKLOAD_CONFIGURATIONS, { solutionId }),
  }).then((response) => {
    if (!response) return { data: [] };
    const configurations = response?.workloadConfigurations ?? response;
    const data = Array.isArray(configurations)
      ? configurations.map((item) => {
          const config = item?.configuration ?? item;
          return {
            ...config,
            activeDeploymentCount: item?.activeDeploymentCount,
            totalDeploymentCount: item?.totalDeploymentCount,
            deploymentSummary: item?.deploymentSummary,
          };
        })
      : [];
    return { data };
  }).catch(() => ({ data: [] }));

const edgeWorkloadConfigurations = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_EDGE_WORKLOAD_CONFIGURATIONS,
});

export default edgeWorkloadConfigurations;
